import React from 'react'
import CustomAlert from '../../shared/CustomAlert'
import { observer } from 'mobx-react-lite'

import AuthStore from './../Auth.store'

import './AuthMessages.scss'

const AuthMessages = () => {
  const message = AuthStore.error || AuthStore.success
  const type = AuthStore.success ? 'success' : 'danger'

  return (
    <div id='AuthMessagesComponent' className={message ? 'show-message' : ''}>
      <CustomAlert color={type}>{message}</CustomAlert>
    </div>
  )
}

export default observer(AuthMessages)
